export const maxTokenCount = 1000;


// WEBPACK FOOTER //
// ./src/portal/states/company/hard-token-management/hard-token-integration/max-token-count.js